webix.protoUI({
	name: "ssheet-ui",
	defaults:{
		move:true,
		css:"webix_shadow_none webix_ssheet_ui",
		head:false,
		resize:true,
		toFront:true,
		minWidth:50,
		minHeight:200,
		escHide:false,
		autofit:false
	},
	$init: function(){
		// prevent block selection
		this.$view.setAttribute("webixignore", "1");
		this.getMenu();

		this.$ready.push(function(){
			webix.UIManager.addHotKey("delete", webix.bind(this._removeView, this));
			webix.UIManager.addHotKey("backspace", webix.bind(this._removeView, this));
		});
		this.attachEvent("onDestruct", function(){
			webix.eventRemove(this._clickEv);
			this._menu.destructor();
		});
	},
	move_setter:function(value){
		if (value){
			webix.DragControl.addDrag(this.$view, this);
		}
		return value;
	},
	$dragPos:function(pos, e){
		this.callEvent("onViewMove", [pos, e]);
		return pos;
	},
	$dragCreate:function(object, e){
		const trg = e.target;
		if (!trg.getAttribute || trg.getAttribute("webix_disable_drag") || trg.getAttribute("webixignore"))
			return;

		this.getMenu().hide();
		const elOffset = webix.html.offset(object);
		const elPos = webix.html.pos(e);
		const pOffset = webix.html.offset(object.parentNode);
		const state = webix.$$(this.config.master).getScrollState();

		webix.DragControl.top = elOffset.y - elPos.y - pOffset.y;
		webix.DragControl.left = elOffset.x - elPos.x - pOffset.x + state.x;

		return webix.toNode(this.$view);
	},
	$dragDestroy:function(node, drag){
		const x = this.config.left = parseInt(drag.style.left,10);
		const y = this.config.top = parseInt(drag.style.top,10);

		webix.DragControl.top = webix.DragControl.left = 0;

		this.callEvent("onViewMoveEnd", [x, y]);
		return;
	},
	getMenu:function(){
		if(!this._menu){
			this._menu = webix.ui({
				view:"contextmenu",
				data:[
					{ id:"edit", value:webix.i18n.spreadsheet.labels["edit-view"] },
					{ id:"del", value:webix.i18n.spreadsheet.labels["remove-view"] }
				],
				on:{
					onItemClick:(id) => this._menuActions(id)
				}
			});
			const dots = webix.html.create("span", {"class":"webix_ssheet_view_menu webix_icon wxi-dots"});
			this._clickEv = webix.event(dots, "click", ()=> {
				if(this._menu.isVisible())
					this._menu.hide();
				else
					this._menu.show(dots);
			});
			this.$view.firstChild.appendChild(dots);
		}
		return this._menu;
	},
	_menuActions:function(id){
		if(id == "del")
			this.callEvent("onViewRemove", []);
		else if(id == "edit")
			this.callEvent("onViewEdit", []);
	},
	_removeView(view){
		if(view && view.getTopParentView() == this)
			this.callEvent("onViewRemove", []);
	}
}, webix.ui.window);